/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Go_To_Start_Aria_LabelInputs */

const en_player_go_to_start_aria_label = /** @type {(inputs: Player_Go_To_Start_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go To Start`)
};

const fr_player_go_to_start_aria_label = /** @type {(inputs: Player_Go_To_Start_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aller au Debut`)
};

const de_player_go_to_start_aria_label = /** @type {(inputs: Player_Go_To_Start_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Start`)
};

const it_player_go_to_start_aria_label = /** @type {(inputs: Player_Go_To_Start_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai all'inizio`)
};

const ru_player_go_to_start_aria_label = /** @type {(inputs: Player_Go_To_Start_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейти к началу`)
};

const es_player_go_to_start_aria_label = /** @type {(inputs: Player_Go_To_Start_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir al inicio`)
};

const zh_cn2_player_go_to_start_aria_label = /** @type {(inputs: Player_Go_To_Start_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回开头`)
};

const ja_player_go_to_start_aria_label = /** @type {(inputs: Player_Go_To_Start_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スタートへ戻る`)
};

const hi_player_go_to_start_aria_label = /** @type {(inputs: Player_Go_To_Start_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शुरुआत पर जाएं`)
};

const pt_pt2_player_go_to_start_aria_label = /** @type {(inputs: Player_Go_To_Start_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir para o início`)
};

/**
* | output |
* | --- |
* | "Go To Start" |
*
* @param {Player_Go_To_Start_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_go_to_start_aria_label = /** @type {((inputs?: Player_Go_To_Start_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Go_To_Start_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_player_go_to_start_aria_label(inputs)
	if (locale === "de") return de_player_go_to_start_aria_label(inputs)
	if (locale === "it") return it_player_go_to_start_aria_label(inputs)
	if (locale === "ru") return ru_player_go_to_start_aria_label(inputs)
	if (locale === "es") return es_player_go_to_start_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_player_go_to_start_aria_label(inputs)
	if (locale === "ja") return ja_player_go_to_start_aria_label(inputs)
	if (locale === "hi") return hi_player_go_to_start_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_player_go_to_start_aria_label(inputs)
	return en_player_go_to_start_aria_label(inputs)
});